import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    changePassword, changeMobile, getPersonalInformation,
    submitEnterpriseCertification, submitPolitCertification,
    getEnterpriseCertificationDataById, getPolitCertificationDataById
} from "@/services";

const usePersonalCenterStore = defineStore("personalCenter", {
    state: () => ({
        // enterpriseCertificateStatus: 'unauthorized',
        // politCertificateStatus: 'unauthorized',
        userInformation: null
    }),
    actions: {
        async changePassword(params) {
            let result = await changePassword(params)
            return result
        },
        async changeMobile(params) {
            let result = await changeMobile(params)
            return result
        },
        async getPersonalInformation() {
            let result = await getPersonalInformation()
            this.userInformation = result.data
            return result.data
        },
        async submitCertification(type, params) {
            let result = null
            switch(type) {
                case 'enterprise': result = await submitEnterpriseCertification(params);break;
                case 'pilot': result = await submitPolitCertification(params);break;
            }
            this.getPersonalInformation()
            return result
        },
        async getCertificationDataById(type) {
            let result = null
            switch(type) {
                case 'enterprise': result = await getEnterpriseCertificationDataById({id: this.userInformation.oneselfOrCompanyId});break;
                case 'pilot': result = await getPolitCertificationDataById({id: this.userInformation.flyAuthenticationId});break;
            }
            return result.data
        },
    },
});

export default usePersonalCenterStore;
